import router from '@/router'

export default function useRouter() {
  return {
    router,
  }
}
